module.exports = __webpack_public_path__ + "assets/img/uzieb-y-farma-small.98c11748.jpg";